import {
  ProjectManagementProjectDetailsPageSettingsBudgetSectionDeleteBudgetDocument,
  ProjectManagementProjectDetailsPageSettingsBudgetSectionDeleteBudgetMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

interface deleteFixedTimeBudgetDto {
  id: number
}

export const useDeleteFixedTimeBudget = () => {
  const [deleteFixedTimeBudget] = useMutation(
    ProjectManagementProjectDetailsPageSettingsBudgetSectionDeleteBudgetDocument,
    {
      extractorFn: (
        data: ProjectManagementProjectDetailsPageSettingsBudgetSectionDeleteBudgetMutation
      ) => data.projectManagementMutations.deleteProjectmanagementFixedTimeBudget,
    }
  )
  return {
    delete(dto: deleteFixedTimeBudgetDto) {
      const { id: fixedTimeBudgetId } = dto
      return deleteFixedTimeBudget({
        variables: {
          id: fixedTimeBudgetId,
        },
        update(cache, mutationResult) {
          const newBudget =
            mutationResult.data?.projectManagementMutations.deleteProjectmanagementFixedTimeBudget
          if (newBudget) {
            cache.evict({
              id: cache.identify({
                id: fixedTimeBudgetId,
                __typename: 'ProjectManagementFixedTimeBudget',
              }),
            })
          }
        },
      })
    },
  }
}
